import { render, staticRenderFns } from "./RiskFactors.vue?vue&type=template&id=6d1d7d06&scoped=true"
import script from "./RiskFactors.vue?vue&type=script&lang=js"
export * from "./RiskFactors.vue?vue&type=script&lang=js"
import style0 from "./RiskFactors.vue?vue&type=style&index=0&id=6d1d7d06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1d7d06",
  null
  
)

export default component.exports